import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Messages";
import getToken from "app/api/getToken";
import { IMessageResponse } from "app/api/types";

export const GET_MESSAGES_REQUEST = "GET_MESSAGES_REQUEST";
export const GET_MESSAGES_SUCCESS = "GET_MESSAGES_SUCCESS";
export const GET_MESSAGES_FAIL = "GET_MESSAGES_FAIL";

export const getMessages = (page: number) => (dispatch: any): any => {
  dispatch({ type: GET_MESSAGES_REQUEST });

  const token = getToken();

  return api
    .getMessages(token, page)
    .then((response: AxiosResponse) => {
      const messages: IMessageResponse = get(response, "data", {});
      dispatch({ type: GET_MESSAGES_SUCCESS, payload: messages });

      return messages;
    })
    .catch(err => {
      dispatch({
        type: GET_MESSAGES_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
